// Apply ResizeObserver polyfill if browser doesn't support it.
// Needed for things like Safari 13 and older: https://caniuse.com/resizeobserver

import { install } from 'resize-observer';

if (!window.ResizeObserver) {
  install();
}
